import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { StatusState } from '../../states/status.state';
import { CreateStatusCommand } from './create-status.command';
import { CreateStatusResult } from './create-status.result';

@Injectable({ providedIn: 'root' })
export class CreateStatusUseCase {
  private readonly repository = inject(StatusRepository);
  private readonly state = inject(StatusState);

  execute(command: CreateStatusCommand): Observable<CreateStatusResult> {
    this.state.setSaving(true);
    this.state.clearErrorSavingStatus();

    return this.repository.createStatus(command).pipe(
      map((result) => ({ id: result.id })),
      catchError((error) => {
        this.state.setErrorSavingStatus(error.message || 'Failed to create status');
        throw error;
      }),
      finalize(() => {
        this.state.setSaving(false);
      }),
    );
  }
}
